export default __webpack_public_path__ + "static/media/fire-extinguisher-icon.2290727e.svg";